export default {
  title: 'Model Composer',
  emptyState: 'Add a channel to start.',
  channelsPending: 'Complete the new channel: set where it saturates and its sales there. | Complete the {count} pending channels: set where each one saturates and its sales there.',
  channelsCompare: 'Saturation curves',
  // Steps, and why Next is disabled on each.
  stepDetails: 'Setup',
  stepChannels: 'Media Channels',
  stepSpend: 'Media Spend',
  stepRevenue: 'Sales',
  stepOtherInputs: 'Other Inputs',
  stepFutureTrends: 'Future Trends',
  stepPreview: 'Model Preview',
  stepHintSource: 'Choose how to start.',
  stepHintDetails: 'Enter a name and a market to continue.',
  stepHintCopyModel: 'Choose a model to copy to continue.',
  stepHintChannels: 'Add at least one channel to continue.',
  stepHintRevenue: 'Enter total sales to continue.',
  create: 'Create Model',
  name: 'Model name',
  nameRequired: 'Name is required.',
  market: 'Market',
  currency: 'Currency',
  frequency: 'Frequency',
  frequencyMonthly: 'Monthly',
  frequencyWeekly: 'Weekly',
  history: 'History',
  historyYears: '{n} year | {n} years',
  comingSoon: 'Coming soon',
  addKpi: 'Add KPI',
  addInput: 'Add Input',
  // Future trends
  futureTrendsIntro: 'Optional. How much each series is expected to grow over the next 12 months. 0% means the same as last year.',
  growthSales: 'Sales',
  growthSalesInfo: 'Expected growth of total sales over the next 12 months, as a range.',
  growthMedia: 'Media spend',
  growthMediaInfo: 'Expected growth of the media spend on this model\'s channels over the next 12 months.',
  growthOtherInfo: 'Expected growth of this spend over the next 12 months.',
  growthMin: 'Min. growth',
  growthMax: 'Max. growth',
  growthLastYear: 'Last 12 months',
  growthNextYear: 'Next 12 months',
  growthChange: 'Change',
  growthNoChange: 'Same as last year',
  growthPastGroup: 'Last 12 months',
  growthFutureGroup: 'Next 12 months (expected)',
  growthPastColumn: 'Last year',
  growthNextColumn: 'Next year',
  growthLegendPast: 'Stated',
  growthLegendFuture: 'Expected range',
  growthLegendMark: 'Same month last year',
  recapFutureTrends: 'Sales growth',
  // Other inputs
  otherInputsIntro: 'Optional. Other spend the model should account for.',
  otherComarketing: 'Co-marketing',
  otherComarketingInfo: 'Brand spend outside this category, such as brand-level advertising. Only the total is needed.',
  otherCompetition: 'Competition',
  otherCompetitionInfo: 'Total media spend of direct competitors in this category.',
  otherTotal: 'Total spend',
  otherAvgMonthInfo: 'Monthly average. Editing it updates the total.',
  otherFlatten: 'Flatten: make the months more even',
  otherRandomize: 'Randomize: make the months more uneven',
  otherShiftLeft: 'Shift one month earlier',
  otherShiftRight: 'Shift one month later',
  otherClear: 'Clear',
  otherAttribution: 'Attribution (% of sales)',
  otherAttributionInfo: 'Share of the year\'s sales credited to this spend, from 0% to 100%. Required once there is a total.',
  otherAttributionInfoCompetition: 'Share of the year\'s sales that competition takes away, from -100% to 0%. Required once there is a total.',
  otherAttributionHint: '≈ {amount} of sales',
  otherAttributionHeld: 'Capped at {cap}%: marketing, seasonality and competition leave no more room.',
  otherAttributionBlank: 'Required.',
  stepHintOtherAttribution: 'Set the attribution of each input with a total to continue.',
  otherAttributionNeedsSpend: 'Enter a total first.',
  decompositionComarketingName: 'Co-marketing',
  decompositionCompetitionName: 'Competition',
  decompositionComarketing: 'the {share}% of sales credited to co-marketing. It comes out of base sales.',
  decompositionCompetition: 'the {share}% of sales that competition takes away. It goes back to base sales.',
  decompositionOtherChosenByModel: 'there is no room left for its share of sales, so the model will choose it. It has no bar here.',
  decompositionOtherByPeriodNote: 'Co-marketing and competition are spread across the months by their spend. The built model adds saturation and carryover, so its months will differ.',
  inputMarketingSpend: 'Media spend',
  inputSeriesName: '{name} input',
  otherImport: 'Import the monthly shape from another model',
  otherSheetShow: 'Edit as table',
  marketRequired: 'Market is required.',
  noSourceModels: 'No models with a finished report.',
  noCopyModels: 'No models available to copy.',
  catalogueRestricted: 'Only models you have access to are listed.',
  reportEmpty: 'This model has no report yet.',
  reportLoadFailed: 'Couldn\'t load this model\'s report: {error}',
  // How a composition starts
  sourceQuestion: 'How do you want to start?',
  sourceScratch: 'From scratch',
  sourceScratchNote: 'Add channels from your models, one by one.',
  sourceCopy: 'Copy a model',
  sourceCopyNote: 'Start from an existing model and edit it.',
  copyModel: 'Model to copy',
  copyName: '{name} (copy)',
  copyFailed: 'Couldn\'t load this model.',
  copyNothing: 'None of this model\'s channels can be copied.',
  copyDone: '{channels} channel copied, with sales of {revenue}. You can edit everything in the next steps. | {channels} channels copied, with sales of {revenue}. You can edit everything in the next steps.',
  copySkippedTitle: 'Channels that couldn\'t be copied',
  copyHeldMonths: 'Seasonality in {months} was capped at {cap}% of base sales.',
  copyAskTitle: 'Replace your channels?',
  copyAsk: 'Copying a model replaces the {channels} channel you added and everything set on it. | Copying a model replaces the {channels} channels you added and everything set on them.',
  copyAskConfirm: 'Replace',
  // Adding channels
  addChannels: 'Add channels',
  importFromModels: 'Import from models',
  importFromModelsNote: 'Take channels, with their curves, from existing models.',
  chooseModel: 'Choose model…',
  changeModel: 'Change',
  copyImporterTitle: 'Choose a model to copy',
  copyImporterSubtitle: 'Search by name, or filter by country, client, brand or category.',
  channelImporterTitle: 'Import channels',
  channelImporterSubtitle: 'Search by model or channel, and filter by model details or channel taxonomy.',
  importerSearchModels: 'Search models',
  importerSearchChannels: 'Search channels or models',
  importerModelFacets: 'Model',
  importerTaxonomyFacets: 'Channel taxonomy',
  importerNoMetadata: 'These models have no metadata yet. You can still search them by name.',
  importerNoModelMatch: 'No models match these filters.',
  importerNotSet: 'Not set',
  importerCurrent: 'Current',
  importerChangeModel: 'Change model',
  importerAllChannels: 'Select all channels of {model}',
  importerPickHint: 'Click a model to choose it.',
  importerFacetCountry: 'Country',
  importerFacetClient: 'Client',
  importerFacetBrand: 'Brand',
  importerFacetCategory: 'Category',
  importerFacetSubcategory: 'Subcategory',
  addFromScratch: 'From scratch',
  addFromScratchNote: 'Create a channel and set its curves yourself.',
  taxonomyFilters: 'Filters',
  taxonomyClear: 'Clear filters',
  taxonomyRemoveFilter: 'Remove filter',
  taxonomyOnlyClassified: 'Only classified channels',
  taxonomyUnclassified: 'Unclassified',
  taxonomyShowAll: 'Show all ({count})',
  taxonomyShowLess: 'Show less',
  taxonomyShowMore: 'Show more',
  taxonomyShowing: 'Showing {shown} of {total}',
  taxonomyNoMatch: 'No channels match these filters.',
  taxonomyNoneYet: 'No channels have a taxonomy yet. You can still search them by name.',
  taxonomyCatalogueLoading: 'Loading models…',
  taxonomyReading: 'Reading {count} model… | Reading {count} models…',
  taxonomyModels: '{count} model | {count} models',
  taxonomySummary: '{channels} from {models}',
  taxonomyNotInReport: 'This channel isn\'t in its model\'s report.',
  taxonomyReadFailed: 'Couldn\'t load this model\'s report.',
  scratchChannel: 'New channel',
  fromScratchOrigin: 'From scratch',
  pickerAdd: 'Add channels | Add {count} channel | Add {count} channels',
  pickerAlready: 'Already added',
  pickerModelAdded: '{count} channel already added | {count} channels already added',
  pickerAddHint: 'Add selected channels (⌘/Ctrl + Enter)',
  pickerNotMeasured: 'Not measured',
  pickerAdded: 'Added',
  pickerPlotSaturation: 'Saturation: sales returned by monthly spend.',
  pickerPlotDecay: 'Decay: how the effect carries over into later months.',
  pickerLoadingNote: 'Loading the model…',
  pickerCount: '{count} channel | {count} channels',
  pickerSelected: '{count} selected',
  pickerSelectAll: 'Select all channels shown',
  notReadyTitle: 'This model can\'t contribute channels',
  notReady_noKpi: 'It has no sales history.',
  notReady_noChannels: 'None of its channels has both spend history and a saturation curve.',
  skipped_noSaturation: '{channel}: no usable saturation curve.',
  skipped_noCurve: '{channel}: its saturation curve has too few points.',
  unbuiltAction: 'Complete',
  channelEditTitle: 'Edit {channel}',
  channelName: 'Channel name',
  editorPrev: 'Previous channel',
  editorNext: 'Next channel',
  saturationCurve: 'Saturation curve',
  saturationPoint: 'Saturation point',
  responseShape: 'Response shape',
  // Decay
  decayTitle: 'Decay',
  decayLagAt: 'Month {month}',
  decayImported: 'As imported',
  decayCustom: 'Custom',
  decayPeak: 'Peak {month}',
  decayShapeTitle: 'Peaks in month {peak}; half of the effect by month {half}',
  decayDrag: 'Drag the tallest bar: sideways to move the peak, up or down to change how fast it fades.',
  decayShapeNow: 'Peak in month {peak} · half of the effect by month {half}',
  decayAbout: 'How a month\'s spend keeps working in the following months: it changes when sales arrive, not how much. Channels from weekly models need a shape picked here.',
  statedOf: '{index} of {count}',
  statedSuffix: 'USD / month',
  unbuiltBlocked: 'No curve available',
  unbuiltChannel: 'Set where {channel} saturates and its sales there to include it in the model.',
  unbuiltNoCurve: '{channel}\'s saturation curve never flattens, so it can\'t be used. Remove it and pick another channel.',
  // Media spend
  metricSpend: 'Media spend',
  metricSpendTotal: 'Total spend',
  metricSpendInfo: 'Total media spend for the year. Pick a level on the chart or enter a target Total ROAS.',
  metricTotalKpi: 'Total sales',
  metricTotalKpiInfo: 'Total sales for the year. It sets how much of the business marketing explains, and its limits depend on media spend.',
  metricAvgMonth: 'Avg. per month',
  metricAvgMonthInfo: 'Monthly average. Editing it updates the total.',
  metricRoas: 'Total ROAS',
  metricRoasInfo: 'Estimated Total ROAS: sales from media divided by media spend. The built model may differ slightly.',
  tradePlotLabel: 'Return by spend',
  tradeMinLabel: 'Min. spend',
  trade_min_attribution: 'Minimum spend: below it, marketing would explain almost none of the sales.',
  trade_min_floor: 'Minimum spend: below it, some channels\' monthly spend would be too small to model.',
  trade_min_window: 'Lowest spend on this chart. Click to go there.',
  tradeMaxLabel: 'Max. spend',
  trade_max_revenue: 'Maximum spend: above it, media spend would exceed sales.',
  trade_max_base: 'Maximum spend: above it, media would be credited with more than total sales.',
  trade_max_attribution: 'Maximum spend: above it, media would be credited with almost all sales.',
  trade_max_window: 'Highest spend on this chart. Click to go there.',
  spendSeated: 'Media spend was set to {spend}, the limit for this model.',
  spendSeatedChannels: 'Media spend was set to {spend}, the limit for the remaining channels.',
  spendSeatedCurves: 'Media spend was set to {spend}, the limit after the curve changes.',
  spendSeatedMonths: 'Media spend was set to {spend}, the limit after the monthly changes.',
  spendHeld: 'Media spend was held at {spend}.',
  // Sales held or moved to stay within the limits
  revenueHeld_spend: 'Sales were held at {revenue}: they must be greater than media spend. Lower the spend to go lower.',
  revenueSeated_spend: 'Sales were set to {revenue} to stay above media spend. Lower the spend to go lower.',
  monthHeld_spend: '{month} was held at {amount}: yearly sales must be greater than media spend.',
  revenueHeld_base: 'Sales were held at {revenue}, the minimum for this media spend. Lower the spend to go lower.',
  revenueSeated_base: 'Sales were set to {revenue}, the minimum for the current media spend. Lower the spend to go lower.',
  monthHeld_base: '{month} was held at {amount}: any lower, media would be credited with more than total sales.',
  revenueFloorHint: 'Minimum at this spend: {revenue}',
  revenueHeld_low: 'Sales were held at {revenue}, the minimum allowed.',
  revenueHeld_high: 'Sales were held at {revenue}: any higher, media would explain almost none of the sales. Add channels or raise media spend.',
  revenueSeated_low: 'Sales were set to {revenue}, the minimum allowed.',
  revenueSeated_high: 'Sales were set to {revenue}, the maximum for the current media spend. Raise the spend to go higher.',
  tradePeakLabel: 'Max. ROAS',
  tradePeak: 'Highest return per dollar. Beyond it, each extra dollar returns less. Click to go there.',
  baseBelowFloor: 'Base sales are below the minimum of {floor} for this media spend. Raise sales to {revenue} or more, or lower media spend.',
  roasOutOfReach: 'This Total ROAS can\'t be reached. With this mix it ranges from {min} to {max}.',
  roasUnsolvable: 'No media spend reaches this Total ROAS.',
  roasOutOfReachEither: 'This Total ROAS can\'t be reached. With this mix it ranges from {min} to {max}; with any mix, from {mixMin} to {mixMax}.',
  roasHeldAt: 'Moved as far as the curves allow: Total ROAS is now {roas}.',
  roasHeldFloor: 'That Total ROAS would need a channel at almost zero spend, so spend was moved as far as possible instead.',
  mixMoved: 'To reach this Total ROAS, budget was shifted between channels. The curves are unchanged.',
  spendMonthsLabel: 'Monthly spend',
  spendMonthsKeys: 'Tab: next field · Enter: apply · Esc: cancel',
  shapeMonthsKeys: 'Tab: next field · Enter: apply · Esc: cancel',
  spendSheetChannels: 'Channel',
  spendSheetShow: 'Edit as table',
  sheetHide: 'Hide table',
  revenueSheetShow: 'Edit as table',
  sharesSheetShow: 'Edit as table',
  sheetSeries: 'Series',
  revenueSheetHeld: 'Sales in {months} were adjusted to stay within the allowed range.',
  shareSheetCell: '{row} in {month} ({value}% of base)',
  shareSheetHeld: '{cells} were adjusted to stay within the allowed range. {reasons}',
  shapeUnit: '% of base',
  shapeCapNote: 'Each value is a share of that month\'s base sales. Together, seasonality and spot events can take up to {cap}% of a month\'s base.',
  spendReturnKpi: 'Sales',
  roasAxis: 'Sales / Spend',
  // Model preview
  previewModelName: 'Model preview',
  decayAxis: 'Months after spend',
  decompositionIntro: 'Where this model\'s sales come from:',
  decompositionBase: 'sales without any media. The built model\'s report will split it into base and noise.',
  decompositionSeasonality: 'the share of sales from recurring yearly patterns. It moves sales between months, so over a year it usually nets close to zero.',
  decompositionMarketingTerm: 'Marketing',
  decompositionMarketing: 'sales returned by all channels at the current media spend.',
  decompositionBaseBelowFloor: 'Seasonality and spot events take {claimed} of the {room} available, leaving base sales below the minimum of {floor}. Reduce them, or lower media spend and raise sales.',
  decompositionBaseNoRoom: 'Media already account for all sales except the minimum base of {floor}, leaving no room for seasonality or spot events. Lower media spend or raise sales.',
  // Sales by month
  metricRevenueShape: 'Sales',
  metricRevenueShapeInfo: 'How total sales are spread across the months. Use the buttons to reshape, shift or import the year, or click a month to edit it.',
  shapeRandomize: 'Randomize: make the months more uneven',
  shapeFlatten: 'Flatten: make the months more even',
  shapeClear: 'Clear',
  shapeShiftLeft: 'Shift one month earlier',
  shapeShiftRight: 'Shift one month later',
  shapeImport: 'Import the monthly shape from another model',
  shapeImportTitle: 'Import sales shape',
  shapeImportSubtitle: 'Use another model\'s monthly sales pattern. Your total stays the same.',
  shapeImportKpi: 'KPI',
  shapeImportTotal: 'Total',
  shapeImportYear: 'Year',
  shapeImportAverage: 'Average of {count} full years',
  shapeImportLoadingNote: 'Loading the report…',
  shapeImportNoYears: 'This model has no full calendar year.',
  shapeImportNoShape: 'This KPI has no sales in the selected year.',
  shapeImportNote: 'Only full calendar years are used. Your total stays the same.',
  shapeImportShiftLeft: 'Shift one month earlier',
  shapeImportShiftRight: 'Shift one month later',
  shapeImportShifted: 'Shifted {count} month | Shifted {count} months',
  shapeImportSeason: 'Import seasonality from another model',
  shapeShiftSeasonLeft: 'Shift one month earlier',
  shapeShiftSeasonRight: 'Shift one month later',
  shapeRandomizeSeason: 'Randomize: make seasonality stronger',
  shapeFlattenSeason: 'Flatten: bring both rows closer to zero',
  shapeClearSeason: 'Clear',
  shapeImportSeasonTitle: 'Import seasonality',
  shapeImportSeasonSubtitle: 'Use another model\'s measured seasonality. Spot events aren\'t imported.',
  shapeImportSeasonNoShape: 'This model has no seasonality in the selected year.',
  shapeImportSeasonNote: 'Only full calendar years are used. Months above the cap are limited to it.',
  shapeImportSeasonApply: 'Use this seasonality',
  shapeImportHeldMonths: '{months} will be capped at {cap}% of base sales.',
  shapeImportApply: 'Use this shape',
  shapeImportOtherTitle: 'Import shape',
  shapeImportOtherSubtitle: 'Use the monthly pattern of another model\'s media or external series. The total stays the same.',
  shapeImportOtherSeries: 'Series',
  shapeImportOtherMedia: 'Media',
  shapeImportOtherMediaTotal: 'All media spend',
  shapeImportOtherExternal: 'External',
  shapeImportOtherNoSeries: 'This model has no media or external series.',
  shapeImportOtherNoShape: 'This series is empty or negative in the selected year.',
  shapeImportOtherNote: 'Only full calendar years are used. The total stays the same.',
  shapeImportOtherNeedsTotal: 'Enter a total first.',
  shapeImportOtherApply: 'Use this shape',
  monthHeld_low: '{month} was held at {amount}, the minimum allowed.',
  monthHeld_high: '{month} was held at {amount}: any higher, media would explain almost none of the sales.',
  // Seasonality and spot events
  metricSeasonality: 'Seasonality',
  seasonalitySection: 'Seasonality',
  metricSeasonalityNet: 'Net over the year',
  metricSeasonalityNetInfo: 'Seasonality summed over the year. Close to zero is normal: it moves sales between months.',
  seasonalityAbout: 'Recurring yearly patterns, as a % of each month\'s base sales. It starts flat.',
  seasonality_stop_attribution: 'Beyond this, attribution would no longer add up to 100%.',
  shapesSection: 'Seasonality & spot events',
  shapesOptional: 'Optional',
  metricShapesNet: 'Net over the year',
  metricSpot: 'Spot events',
  spotSection: 'Spot events',
  metricSpotNet: 'Net over the year',
  metricSpotNetInfo: 'Spot events summed over the year. Unlike seasonality, they don\'t cancel out.',
  spotAbout: 'One-off events, such as a launch, a promotion or a stock-out, as a % of that month\'s base sales.',
  shapesHow: 'Click a month to edit both values. They come out of base sales and are limited by the cap shown above the chart.',
  spot_stop_attribution: 'Beyond this, attribution would no longer add up to 100%.',
  decompositionSpot: 'the share of sales from one-off events. It comes out of base sales.',
  // Channel cards
  channels: 'Channels',
  channelsInfoMixed: 'Budget is no longer split evenly between channels.',
  channelRemove: 'Remove {channel}',
  channelRemoveLast: 'A model needs at least one channel.',
  channelRemoveTitle: 'Remove this channel?',
  channelRemoveText: '{channel} and all its settings will be removed. This can\'t be undone.',
  channelRemoveConfirm: 'Remove',
  channelNameEmpty: 'Enter a channel name.',
  channelNameTaken: 'Another channel already has this name.',
  fromModel: '{model} · {channel}',
  saturation: 'Saturation',
  decay: 'Decay',
  noCurve: 'No curve',
  spend: 'Spend',
  lagMonths: 'Months',
  cardPoint: '{channel} saturates at {knee} USD a month and generates {ceiling} USD a month there. Click to edit.',
  cardPointUnstated: 'Saturation point not set yet. Click to set it.',
  channelKnee: 'Saturates at',
  channelKneeTitle: 'Monthly spend at which {channel} stops paying off: beyond it, each extra dollar returns less and less.',
  channelCeiling: 'Sales at saturation',
  channelCeilingTitle: 'Monthly sales {channel} generates at its saturation point.',
  // Channel editor
  revenue: 'Sales',
  curveEditAction: 'Edit channel',
  curveEditMoved: 'Edit {channel} (the dashed line is the original curve)',
  editorSaveNext: 'Save & complete next',
  editorSave: 'Save',
  editorCancel: 'Cancel',
  editorLeaveTitle: 'Unsaved changes',
  editorLeaveText: 'Changes to {channel} will be lost if you close now.',
  editorLeaveStepText: 'Changes to {channel} will be lost if you move to another channel.',
  editorLeaveSave: 'Save',
  editorLeaveDiscard: 'Discard',
  editorLeaveStay: 'Keep editing',
  curveReset: 'Reset to original',
  curveCeiling: 'Maximum sales',
  curveKneeInfo: 'Monthly spend at which the channel reaches half its maximum sales. Move it right to saturate later.',
  curveCeilingInfo: 'The most this channel can return, however much is spent.',
  curveKnee: 'Half-saturation spend',
  curveSteepness: 'Steepness',
  curveSteepnessInfo: 'How sharply the curve bends. Above 1, the channel needs a minimum spend before it starts working.',
  curveSeriesCurrent: 'Current',
  curveSeriesOriginal: 'Original',
  curveNoteSampled: 'These levers can\'t match the original curve exactly, so moving one also changes its shape.',
  zonesBegin: 'Optimal zones',
  zoneBegins: 'Where {zone} begins',
  zoneDrag: 'Drag to move where {zone} begins',
  zonesHold: 'Keep fixed:',
  zonesHoldSaturation: 'Saturation point',
  zonesHoldSaturationHint: 'Dragging reshapes the curve; the saturation point stays put.',
  zonesHoldShape: 'Shape',
  zonesHoldShapeHint: 'Dragging slides all zones together; the saturation point moves with them.',
  zonesHoldEdgeHint: 'Where {zone} begins stays put; the other boundaries and the saturation point move.',
  zonesNone: 'This curve is too flat to have optimal zones. Raise Steepness to bring them back.',
  zonesNoneSimple: 'This curve is too flat to have optimal zones. Open Response shape and raise Steepness to bring them back.',
  zonesHeld: 'This boundary is the saturation point, which is kept fixed. Edit it in the field beside the chart.',
  zonesHeldEdge: 'This boundary is kept fixed. Keep something else fixed to drag it.',
  zonesHow: 'Drag or type a boundary to move the zones. The switch above the bar sets what stays fixed while you do.',
  curve_stop_attribution: 'Beyond this, marketing attribution would be out of range.',
  curve_stop_base: 'Beyond this, media would be credited with more than total sales.',
  curve_stop_floor: 'Beyond this, the channel would generate less than 1 USD a month.',
  curveAboutTitle: 'Channel editor',
  curveAbout: 'Sales this channel returns at each monthly spend, taken from its source model. Edits only apply to the new model.',
  curveHow: 'The three levers set the curve\'s shape. Changing it changes what the same spend returns.',
  responseShapeHint: 'Fine-tune the curve with Steepness, Half-saturation spend and Maximum sales.',
  zonesAdjust: 'Adjust zones',
  zonesAdjustHint: 'Drag the zone boundaries and choose what stays fixed.',
  curveSimple: 'The curve is set by the saturation point and its sales. Open Response shape to adjust its shape.',
  // Save
  checkTitle: 'Before creating',
  createAnyway: 'Create anyway',
  goBack: 'Go back'
}
